import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import { getConfig, isConfigLoaded } from "../config";

const REDIRECT_URI = `${window.location.origin}/auth/callback`;
const POST_LOGOUT_URI = `${window.location.origin}/login`;

let userManager: UserManager | null = null;

export function getUserManager(): UserManager {
  if (!userManager) {
    if (!isConfigLoaded()) {
      throw new Error("Configuration not loaded. Call loadConfig() before getUserManager().");
    }
    const cfg = getConfig();
    userManager = new UserManager({
      authority: cfg.keycloakAuthority,
      client_id: cfg.keycloakClientId,
      redirect_uri: REDIRECT_URI,
      post_logout_redirect_uri: POST_LOGOUT_URI,
      response_type: "code",
      scope: "openid profile email",
      automaticSilentRenew: true,
      silent_redirect_uri: `${window.location.origin}/silent-renew.html`,
      monitorSession: false,
      userStore: new WebStorageStateStore({ store: window.localStorage }),
    });
  }
  return userManager;
}
